import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import QuizMiddleware from '../../store/middleware/quizMiddleware';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

var user;

class AdditionalFields extends Component {
    constructor() {
        super();
        this.state = {
            obj: {},
            networkLostError : false,
            additionalFieldsLoader : false
        }
    }

    componentWillReceiveProps(nextprops) {
        var userProps = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        if(!userProps){
            this.props.history.push('/');
        }

        if (nextprops.answerAndQuestionData && nextprops.answerAndQuestionData.question && nextprops.answerAndQuestionData.answerSheet) {
            this.props.history.replace('/quiz/start', { 
                questionDetails: nextprops.answerAndQuestionData.question, 
                answerSheetDetails: nextprops.answerAndQuestionData.answerSheet, 
                quizDetails: this.props.location.state.quizDetails, 
                userDetails: user, 
                classDetails : this.props.location.state.classDetails, 
                time : this.props.location.state.quizDetails.quiz.duration, 
                attemptedQuestions : nextprops.attemptedQuestions, 
                totalQuestions : nextprops.totalQuestions
            })
        }
        if (nextprops.errorInQuizStart) {
            this.setState({
                networkLostError : true
            })
        }
    }

    submitAdditionalFields(e) {
        e.preventDefault();
        this.setState({
            additionalFieldsLoader : true
        })
        let data = {...this.state.obj};
        let arr = Object.keys(data).map((val,ind)=>{
            return{
                name:val,
                value:Object.values(data)[ind]
            }
        })
        this.props.startQuiz({ 
            additionalFields: arr, 
            quizId: this.props.location.state.quizDetails.quiz._id, 
            courseId: this.props.location.state.quizDetails.quiz.course, 
            userId: user._id, 
            pc_access_token: user.pc_access_token, 
            classId: this.props.location.state.classDetails._id
        })
    }

    handleChange(event){
        let currentObjInState = this.state.obj;
        currentObjInState[event.target.id] = event.target.value
        this.setState({
          obj: currentObjInState
        })
    }

    render() {
        user = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        return (
            <div style={{ top: "25%", justifyContent: "center", alignItems: "center", display: "flex", width: "100%", flexDirection: "column", position: "absolute" }}>
                <Paper style={{ width: "50%", padding: "30px" }}>
                    <Typography style={{ fontWeight: "bold", fontSize: "30px" }} >
                        Quiz : {this.props.location.state.quizDetails.quiz.title}
                    </Typography>
                    <form onSubmit={(e) => this.submitAdditionalFields(e)} autoComplete="off">
                        {this.props.location.state.additionalFields && this.props.location.state.additionalFields.length && this.props.location.state.additionalFields.map((data, index) => {

                            return <TextField
                                disabled={this.props.buttonDisable ? true : null }
                                key={index}
                                margin="normal"
                                id={data.name}
                                label={data.name}
                                type="text"
                                fullWidth
                                required
                                onChange={(data) => {this.handleChange(data) , this.setState({ networkLostError : false })}}
                            />
                        })}
                        <Typography style={this.state.networkLostError ? { display: "block", color: 'red', fontSize: '12px' } : { display: "none" }}>* Failed in quiz start, due to network lost</Typography>

                        {this.state.additionalFieldsLoader ?
                            <div style={{ flexDirection: "column", display: "flex", alignItems: "center", justifyContent: "center", height : "10vh" }}>
                                <CircularProgress size={50} thickness={3} style={{color : "#13a89e"}}/>
                            </div>
                        :
                            <Button type="Submit" disabled={this.props.buttonDisable ? true : null } color={this.props.buttonDisable ? null : "primary"} variant="contained" style={{ float: "right", marginTop: "3%", backgroundColor : "#13a89e" }}>Start Quiz</Button>
                        }
                    
                    </form>
                </Paper>
            </div>

        )
    }
}

function mapStateToProps(state) {
    return {
        answerAndQuestionData: state.quizReducer.startQuiz.answerAndQuestionData,
        buttonDisable : state.errorReducer.buttonDisable,
        errorInQuizStart : state.quizReducer.errorInQuizStart,
        attemptedQuestions : state.quizReducer.startQuiz.attemptedQuestions,
        totalQuestions :state.quizReducer.startQuiz.totalQuestions,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        startQuiz: (data) => dispatch(QuizMiddleware.startQuizMiddleware(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalFields);


// WEBPACK FOOTER //
// ./src/container/AdditionalFields/additionalfields.js